// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__T9-74"};